import type { LazyQueryHookOptions } from "@apollo/client"
import { useLazyQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/company/customer.company.search.query.gql"
import type {
  CustomerCompanySearchQuery,
  CustomerCompanySearchQueryVariables,
} from "@/v2-backoffice-client/customer/company/__types__/customer.company.search.query"

type Options = LazyQueryHookOptions<
  CustomerCompanySearchQuery,
  CustomerCompanySearchQueryVariables
>

export function useCustomerCompanySearchLazyQuery(options?: Options) {
  return useLazyQuery<
    CustomerCompanySearchQuery,
    CustomerCompanySearchQueryVariables
  >(query, options)
}
